export const HIDDEN_PAID_POSTS = ['8456fdf4-4c2b-4429-91ad-e8ee49299c9b'];
